export default __webpack_public_path__ + "static/media/ic_copper_level_1.55fcb5d5.png";